<template>
  <div class="absolute top-0px ledger-tab">
    <div
      v-for="item of ledgerTabList"
      :key="item.code"
      class="ledger-tab-item"
      :class="activeTabClass(item)"
      @click="changeTab(item)"
    >
      {{ item.tabName }}
    </div>
  </div>
</template>

<script>
import EventBus from '@/assets/js/EventBus'

export default {
  props: {
    transferProps: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      //设备台账二级菜单列表
      ledgerTabList: [
        {
          tabName: '基础信息',
          name: '设备基础信息',
          code: 'DeviceRealBasicInfo',
          origin: 'DeviceLedger',
        },
        // {
        //   tabName: '关联文档',
        //   name: '设备关联文档',
        //   code: 'DeviceDocs',
        //   origin: 'DeviceLedger',
        // },
        {
          tabName: '关联监控',
          name: '设备关联监控',
          code: 'DeviceMonitor',
          origin: 'DeviceLedger',
        },
        // {
        //   tabName: '缺陷记录',
        //   name: '设备缺陷记录',
        //   code: 'DeviceDefectRecord',
        //   origin: 'DeviceLedger',
        // },
        // {
        //   tabName: '维护记录',
        //   name: '设备维护记录',
        //   code: 'DeviceMaintainRecord',
        //   origin: 'DeviceLedger',
        // },
      ],
      //当前选中的tab
      activeTab: {},
    }
  },
  methods: {
    changeTab(data) {
      EventBus.$emit('ledgerChangeTab', {
        toCom: data,
        type: 'mainComponent',
        props: this.transferProps,
      })
      this.activeTab = data
    },
  },
  computed: {
    activeTabClass() {
      return (item) => {
        if (item.code === this.activeTab.code) {
          return 'active'
        }
        return ''
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.ledger-tab {
  display: flex;
  flex-direction: column;
  left: -45px;
  .ledger-tab-item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 40px;
    height: 100px;
    padding: 0 10px;
    margin-bottom: 20px;
    text-align: center;
    background-color: #2a4e51;
    color: #fff;
    font-size: 14px;
    cursor: pointer;
  }
  .active {
    color: #9aeaff;
  }
}
</style>
